import { http, setFormData } from '@/utils/http'
import { setUserToken, unsetUser } from '@/utils/auth'

import { AUTH_LOGIN, AUTH_LOGOUT } from '@/store/actions/auth'
import { USER_SET, USER_UNSET } from '@/store/actions/user'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  [AUTH_LOGIN]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const model = payload.isAdmin ? 'administrator' : 'agent'
      // set params from payload and use them for login
      const params = setFormData(payload.credentials)
      http.post(model + '/login', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            const token = response.data.token
            // console.log('Logged in', token)

            // set user id in params and get user data
            const params = setFormData({ _id: response.data._id })
            http.post(model + '/read', params, {
              headers: { 'user_session_token': token }
            })
              .then(({ data: response }) => {
                if (response.code === 200) {
                  const user = response.data[0]
                  // If user is inactive?
                  if (user.status === 'inactive') {
                    const error = { message: 'Your account is inactive, please contact the Admin' }
                    reject(error)
                    return
                  }
                  setUserToken(token)
                  http.defaults.headers.common['user_session_token'] = token

                  // if admin login, set to admin, else leave as is
                  user.role = payload.isAdmin ? 'admin' : user.role
                  // console.log('Got user', user)
                  
                  commit(USER_SET, user)
                  resolve(response.code)
                }
                else {
                  unsetUser()
                  reject(response)
                }
              })
          }
          else {
            unsetUser()
            reject(response)
          }
        })
    })
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise((resolve) => {
      unsetUser()
      commit(USER_UNSET)
      const params = setFormData({ token: http.defaults.headers.common['user_session_token'] })
      http.post('user_session/invalidate', params)
      delete http.defaults.headers.common['user_session_token']
      resolve()
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
